import React from "react";
import "./Badge.scss";

// Fontaine M22 — Tag: static label (brand, category, reference). Not clickable, not a status.

/**
 * @param {ReactNode} [icon]
 * @param {"sm"|"md"} [size="md"]
 * @param {boolean} [mono]     reference numbers (tabular, monospace)
 */
export default function Tag({ children, icon, size = "md", mono = false, className = "", ...rest }) {
  const classes = ["ft-tag", `ft-tag--${size === "sm" ? "sm" : "md"}`, mono ? "ft-tag--mono" : "", className].filter(Boolean).join(" ");
  return (
    <span className={classes} {...rest}>
      {icon ? <span className="ft-tag__icon" aria-hidden="true">{icon}</span> : null}
      {children}
    </span>
  );
}
